import { Injectable } from '@angular/core';
import { DatabaseProvider } from '../database/database';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

@Injectable()
export class CategoriesStoreProvider {

	private db = new DatabaseProvider();
	public categoriesList: BehaviorSubject<any> = new BehaviorSubject([]);

	constructor() {
	}


	addBatch(categoriesList) {

		return new Promise((resolve, reject) => {

			this.db.categories.clear().then(() => {

				this.db.categories.bulkAdd(categoriesList).then((data) => {

					this.loadList()
					resolve(data);

				}).catch((e) => reject(e))

			}).catch((e) => reject(e))

		})

	}

	loadList() {

		return new Promise((resolve, reject) => {

			this.db.categories.toArray().then((data) => {

				this.manipulateList(data).then((list) => {

					this.categoriesList.next(list);
					resolve(true);

				}).catch((e) => reject(e))

			}).catch((e) => reject(e))

		})

	}


	private manipulateList(categoriesList) {

		return new Promise((resolve, reject) => {

			let list = []

			if (categoriesList && categoriesList.length > 0) {

				categoriesList.forEach((caterory) => {

					list.push({
						id: caterory.id,
						name: caterory.catname
					})

				})

			}

			resolve(list);

		})


	}

}



// WEBPACK FOOTER //
// ./src/providers/categories-store/categories-store.ts